
<template>
  <div>
    <div class="text item">
      <el-form
        ref="form"
        :model="form"
        label-width="200px"
        style="width: 100%"
        :rules="rules"
      >
       <el-form-item label="是否禁用" prop="disabled" >
          <el-radio
            v-model="form.disabled"
            :label="item.value"
            v-for="(item, index) in disabledArr"
            :key="index"
            >{{ item.name }}</el-radio
          >
        </el-form-item>
      <el-card class="box-card" >
        <el-row>
          <el-alert title="运营联系人信息" type="success" :closable="false">
          </el-alert>
        </el-row>
        <el-row>

            <el-form-item label="运营联系人姓名" prop="contact_name">
              <el-input
                style="width: 200px"
                v-model="form.contact_name"
                placeholder="运营联系人姓名"
              ></el-input>
            </el-form-item>

            <el-form-item label="运营联系人电话" prop="contact_mobile">
              <el-input
                style="width: 200px"
                v-model="form.contact_mobile"
                placeholder="运营联系人电话"
              ></el-input>
            </el-form-item>
        </el-row>

      </el-card>
        <el-card class="box-card" >
          <el-row>
            <el-alert title="入驻企业信息" type="success" :closable="false">
            </el-alert>
          </el-row>
          <el-form-item label="品牌名称" prop="name">
            <el-input
            style="width:600px"
              placeholder="（请填写您的品牌名称）"
              v-model="form.name"
            ></el-input>
          </el-form-item>
          <el-form-item label="经营品类" prop="operating_type_id">
            <template
              v-if="
                $route.query.id == undefined ||
                ($route.query.id == undefined && !form.operating_type_id)
              "
            >
              <el-cascader
                :options="mainCategory"
                v-model="selectedMainCategory"
                @change="handleCategoryChange"
                style="width: 360px"
              >
              </el-cascader>
              <el-tag type="danger">
                请选择您的店铺主营品类，填写后不可更改
              </el-tag>
            </template>
            <div
              class="content-padded view-flex view-flex-middle"
              v-loading="loader"
              v-else
            >
              <el-breadcrumb
                separator-class="el-icon-arrow-right"
                class="inline"
              >
                <el-breadcrumb-item
                  v-for="(item, index) in categoryNames"
                  :key="index"
                  >{{ item }}</el-breadcrumb-item
                >
              </el-breadcrumb>
            </div>
          </el-form-item>
          <!-- // -->
            <el-form-item label="经营品类(辅营)" >
                  <el-cascader
                   v-model="form.other_category_ids"
                  :options="mainCategory"
                  :props="props"
                >
                </el-cascader>
              </el-form-item>
          <el-row>
            <el-col :span="8">
                 <el-form-item label="入驻商户类型" prop="merchant_type">
                <el-radio
                  v-model="form.merchant_type"
                  :label="item.value"
                  v-for="(item, index) in merchant_typeArr"
                  :key="index"
                  >{{ item.name }}</el-radio
                >
              </el-form-item>
            </el-col>
             <el-col :span="8">
  <el-form-item label="商家类型" prop="type">
            <el-radio
              v-model="form.type"
              :label="item.value"
              v-for="(item, index) in typeArr"
              :key="index"
              >{{ item.name }}</el-radio
            >
          </el-form-item>
                </el-col>

          </el-row>
          <el-form-item label="平台服务费一" prop="platform_service_rate">
            <el-input
             style="width:600px"
              v-model="form.platform_service_rate"
              placeholder="费率（[提现手续费率]包含进费率里面） 比如 5% 就填 5"
            ></el-input>
          </el-form-item>
          <el-form-item label="平台服务费二" prop="platform_service_base_fee">
            <el-input
             style="width:600px"
              v-model="form.platform_service_base_fee"
              placeholder="[预留]复诊开方及处方流转等技术服务费(固定值)"
            ></el-input>
          </el-form-item>
          <el-form-item label="起送门槛设置" prop="threshold_setting">
            <el-input
             style="width:200px"
              v-model="form.threshold_setting"
              placeholder="起送门槛设置/元"
            ></el-input>
          </el-form-item>
          <el-form-item label="商家承担配送费" prop="merchant_freight_fee">
            <el-input
             style="width:200px"
              v-model="form.merchant_freight_fee"
              placeholder="商家承担配送费/元"
            ></el-input>
          </el-form-item>
          <el-form-item label="企业名称" >
            <el-input
             style="width:600px"
              v-model="form.business_name"
              placeholder="企业名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="营业执照">
            <div
              @click="handleImgPicker('business_license')"
              class="upload-box"
            >
              <img
                v-if="form.business_license"
                :src="form.business_license"
                class="avatar"
              />
              <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
            </div>
            <div class="frm-tips">只能上传jpg/png文件，且不超过500KB</div>
          </el-form-item>
          <el-form-item label="注册号" >
            <el-input
             style="width:600px"
              v-model="form.business_license_no"
              placeholder="请填写营业执照注册号"
            ></el-input>
          </el-form-item>
          <el-form-item label="执照名称"  >
            <el-input
             style="width:600px"
              v-model="form.business_license_name"
              placeholder="执照名称（请填写营业执照名称）"
            ></el-input>
          </el-form-item>
          <el-form-item label="公司经营地址" >
            <el-input
             style="width:600px"
              v-model="form.business_address"
              placeholder="请填写与您营业执照照片中地址保持一致"
            ></el-input>
          </el-form-item>
          <el-form-item label="营业有效期" >
            <el-date-picker
              @change="selectTime()"
              :disabled="timelimitDisabled"
              v-model="form.business_expire"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            <el-checkbox v-model="timelimit" @change="changeTime()"
              >长期有效</el-checkbox
            >
          </el-form-item>


        </el-card>


        <el-card class="box-card">
          <el-row>
            <el-alert
              title="企业法定代表人基本信息(个人/企业法人)"
              type="success"
              :closable="false"
            >
            </el-alert>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="姓名">
                <el-input
                  v-model="form.operate_name"
                  placeholder="请填写营业执照中的法人"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="手机号" >
                <el-input
                  v-model="form.operate_mobile"
                  placeholder="手机号"
                ></el-input>
              </el-form-item>
            </el-col>
           </el-row>
           <el-row>
            <el-col :span="8">
              <el-form-item label="证件号码">
            <el-input
              v-model="form.identity_no"
              placeholder="证件号码（身份证）"
            ></el-input>
          </el-form-item>
           </el-col>

           <el-col :span="8">
          <el-form-item label="证件类型" prop="identity_type" >
            <el-radio
              v-model="form.identity_type"
              :label="item.value"
              v-for="(item, index) in identity_typeArr"
              :key="index"
              >{{ item.name }}</el-radio
            >
          </el-form-item>
           </el-col>
           </el-row>
           <el-row>
            <el-col>  <el-tag type="danger">注意:身份证图片大小不超过500KB</el-tag></el-col>
           </el-row>
          <el-row>

            <el-col :span="12">
              <el-form-item label="身份证正面" >
                <div
                  @click="handleImgPicker('identity_front')"
                  class="upload-box"
                >
                  <img
                    v-if="form.identity_front"
                    :src="form.identity_front"
                    class="avatar"
                  />
                  <i
                    v-else
                    class="iconfont icon-camera avatar-uploader-icon"
                  ></i>
                </div>
                <div class="frm-tips">
                  身份证正面|只能上传jpg/png文件，且不超过500KB
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证反面" >
                <div
                  @click="handleImgPicker('identity_backend')"
                  class="upload-box"
                >
                  <img
                    v-if="form.identity_backend"
                    :src="form.identity_backend"
                    class="avatar"
                  />
                  <i
                    v-else
                    class="iconfont icon-camera avatar-uploader-icon"
                  ></i>
                </div>
                <div class="frm-tips">
                  身份证反面|只能上传jpg/png文件，且不超过500KB
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="身份证有效日期" >
            <el-date-picker
              v-model="form.identity_begintime"
              type="date"
              placeholder="开始日期"
            >
            </el-date-picker>
            <el-date-picker
              v-model="form.identity_endtime"
              type="date"
              placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>

        </el-card>



        <el-form-item :hidden="$route.query.id == undefined ? btn1 : true">
          <el-button @click="next(1)" type="danger"
            >下一步,补充资质信息</el-button
          >
        </el-form-item>
        <el-card :hidden="$route.query.id == undefined ? next1 : false">
          <el-row>
            <el-alert title="补充资质信息(可添加多个资质)" type="success" :closable="false">
            </el-alert>
          </el-row>
          <el-row :gutter="20">
            <el-card
              style="width: 40%; display: inline-block; margin: 20px"
              v-for="(v, index) in form.credentialArr"
              :key="index"
            >
              <div slot="header" class="clearfix">
                <span>补充资质信息:{{ index + 1 }}</span>
                <el-button
                  style="float: right; padding: 3px 0"
                  type="text"
                  @click="removeForm(index)"
                  v-if="index != 0"
                  >删除</el-button
                >
              </div>
              <el-form-item
                label="资质证件类型"

              >
                <el-select v-model="v.credential_type_id" placeholder="请选择">
                  <el-option
                    v-for="item in typeList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="资质证件图片"

              >
                <div
                  @click="handleImgPicker('credential_url', index)"
                  class="upload-box"
                >
                  <img
                    v-if="v.credential_url"
                    :src="v.credential_url"
                    class="avatar"
                  />
                  <i
                    v-else
                    class="iconfont icon-camera avatar-uploader-icon"
                  ></i>
                </div>
                <div class="frm-tips">
                  资质证件图片|只能上传jpg/png文件，且不超过500KB
                </div>
              </el-form-item>
              <el-form-item
                label="有效期至"

              >
                <el-date-picker
                  v-model="v.credential_expire"
                  type="date"
                  value-format="yyyy-MM-DD"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-card>
            <el-form-item>
              <el-button type="text" @click="addRule()">+补充资质</el-button>
            </el-form-item>
          </el-row>
        </el-card>
        <el-form-item :hidden="$route.query.id == undefined ? btn2 : true">
          <el-button @click="next(2)" type="danger"
            >下一步,补充对公账户信息</el-button
          >
        </el-form-item>
        <el-card :hidden="$route.query.id == undefined ? next2 : false">
          <el-row>
            <el-alert title="补充对公账户信息" type="success" :closable="false">
            </el-alert>
          </el-row>
          <el-row>
            <el-form-item label="企业对公账户" v-if="form.merchant_type == 1"

            >
              <el-input
              style="width:600px"
                placeholder="企业对公账户"
                v-model="form.accountArr.account_no"
              ></el-input>
            </el-form-item>
            <el-form-item label="开户银行名称"  >
              <el-input
              style="width:600px"
                placeholder="开户银行名称"
                v-model="form.accountArr.parent_bank_name"
              ></el-input>
            </el-form-item>
            <el-form-item label="开户行支行名称"  >
              <el-input
                placeholder="开户行支行名称"
                 style="width:600px"
                v-model="form.accountArr.bank_name"
              ></el-input>
            </el-form-item>
            <el-form-item label="支付行号" v-if="form.merchant_type == 1" >
              <el-input
              style="width:600px"
                placeholder="支付行号[企业支付行号12位数字"
                v-model="form.accountArr.union_bank"

              ></el-input>
            </el-form-item>
            <el-form-item label="银行卡号"  v-else >
              <el-input
              style="width:600px"
                placeholder="填写银行卡号"
                v-model="form.accountArr.union_bank"
              ></el-input>
              <el-tag type="danger">银行卡号必须和身份证姓名一致</el-tag>
            </el-form-item>
            <el-form-item label="开户行所在地" >
              <el-cascader
                clearable
                v-model="form.accountArr.regions_id"
                :options="regions"
                @change="handleRegionChange"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="开户行地区代码">
              <el-input
               style="width:600px"
                placeholder="开户行地区代码（非必填）"
                v-model="form.accountArr.bank_city_no"
              ></el-input>
            </el-form-item>
          </el-row>
        </el-card>
        <el-form-item :hidden="hidden">
          <el-button type="primary" @click="onSubmit('form')">保存</el-button>
          <el-button @click="goBack('form')">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
    <imgPicker
      :dialog-visible="imgDialog"
      :sc-status="isGetImage"
      @chooseImg="pickImg"
      @closeImgDialog="closeImgDialog"
    ></imgPicker>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import imgPicker from "@/components/imageselect";
import draggable from "vuedraggable";
import {
  getMerchants,
  addMerchants,
  editMerchants,
  getMerchantCategory,
  getMerchantCredentialTypes,
} from "../../../api/merchant";
import district from "../../../common/district.json";
// 取选中地区的值
function getCascaderObj(val, opt) {
  return val.map(function (value, index, array) {
    for (var itm of opt) {
      if (itm.value === value) {
        opt = itm.children;
        return itm;
      }
    }
    return null;
  });
}

export default {
  data() {
    return {
      props: { multiple: true },
      regions: district,
      btn1: false,
      btn2: true,
      next1: true,
      next2: true,
      hidden: true,
      pickerImgType: "",
      imgDialog: false,
      isGetImage: false,
      mainCategory: [],
      selectedMainCategory: [],
      loader: true,
      categoryNames: [],
      mainCateLoader: false,
      timelimit: false,
      timelimitDisabled: false,
      typeList: [],
      typeArr: [
        { name: "加盟", value: 1 },
        { name: "直营", value: 0 },
      ],
      merchant_typeArr: [
        { name: "企业", value: 1 },
        { name: "个人", value: 0 },
      ],
      disabledArr: [
        { name: "否", value: 0 },
        { name: "是", value: 1 },
      ],
      identity_typeArr: [
        { name: "身份证", value: 1},
        { name: "护照", value: 2 },
        { name: "军官证", value: 3 },
        { name: "回乡证", value: 4 },
        { name: "台胞证", value: 5 },
        { name: "警官证", value: 6 },
        { name: "士兵证", value: 7 },
        { name: "户口簿", value: 8 },
        { name: "港澳居民来往内地通行证", value: 9 },
        { name: "临时身份证", value: 10 },
        { name: "外国人居留证", value: 11 },
        { name: "港澳台居民居住证", value: 12 },
        { name: "其他证件", value: 99 },

      ],
      form: {
        name: "",
        merchant_type: 1,
        operating_type_id: "",
        other_category_ids:{},
        type: 1,
        business_name: "",
        business_license: "",
        business_license_no: "",
        business_license_name: "",
        business_address: "",
        business_expire: "",
        operate_name: "",
        operate_mobile: "",
        identity_front: "",
        identity_backend: "",
        identity_type: 1,
        identity_no: "",
        identity_begintime: "",
        identity_endtime: "",
        contact_name: "",
        contact_mobile: "",
        disabled: 0,
        platform_service_base_fee:'',
        platform_service_rate:'',
        tax_register:'',
        organization_code:'',
        threshold_setting:0,
        merchant_freight_fee:0,
        credentialArr: [
          {
            credential_type_id: "",
            credential_expire: "",
            credential_url: "",
          },
        ],
        accountArr: {
          disabled: 0,
          account_no: "",
          parent_bank_name: "",
          bank_name: "",
          union_bank: "",
          bank_city_no: "",
          regions_id: "",
          province: "",
          city: "",
          area: "",
        },
      },
      credential_url_index: -1,
      rules: {
        name: {
          required: true,
          message: "请填写您的品牌名称!",
          trigger: "blur",
        },
        type: {
          required: true,
          message: "请选择商家类型!",
          trigger: "blur",
        },
        merchant_type: {
          required: true,
          message: "请选择入驻商户类型!",
          trigger: "blur",
        },
        platform_service_rate:{
          required: true,
          message: "费率!",
          trigger: "blur",
        },
        business_license_no: {
          required: true,
          message: "请填写营业执照注册号!",
          trigger: "blur",
        },
        operating_type_id: {
          required: true,
          message: "请选择您的店铺主营品类!",
          trigger: "blur",
        },
        business_name: {
          required: true,
          message: "请填写您的企业名称!",
          trigger: "blur",
        },
        business_license: {
          required: true,
          message: "上传营业执照图片!",
          trigger: "blur",
        },
        business_license_name: {
          required: true,
          message: "请填写营业执照名称!",
          trigger: "blur",
        },
        business_address: {
          required: true,
          message: "请填写与您营业执照照片中地址保持一致!",
          trigger: "blur",
        },
        business_expire: {
          required: true,
          message: "请填写您营业有效期,或选择长期有效!",
          trigger: "blur",
        },
        operate_name: {
          required: true,
          message: "请填写营业执照中的法人!",
          trigger: "blur",
        },
        operate_mobile: [
          {
            required: true,
            message: "个人经营者/企业法定代表人手机号码!",
            trigger: "blur",
          },
          {
            min: 11,
            max: 11,
            message: "请输入正确的手机号码!",
            trigger: "blur",
          },
        ],
        identity_front: {
          required: true,
          message: "身份证正面照片（企业法人/经营者）",
          trigger: "blur",
        },
        identity_backend: {
          required: true,
          message: "身份证背面照片（企业法人/经营者）",
          trigger: "blur",
        },
        identity_type: {
          required: true,
          message: "个人/企业法人证件类型（身份证）",
          trigger: "blur",
        },
        identity_no: [
          {
            required: true,
            message: "个人/企业法人证件号码",
            trigger: "blur",
          },
          { min: 18, max: 18, message: "身份证必须18位!", trigger: "blur" },
        ],
        identity_begintime: {
          required: true,
          message: "个人/企业法人证件有效开始日期",
          trigger: "blur",
        },
        identity_endtime: {
          required: true,
          message: "个人/企业法人证件有效截至日期",
          trigger: "blur",
        },
        contact_name: {
          required: true,
          message: "运营联系人姓名",
          trigger: "blur",
        },
        contact_mobile: [
          {
            required: true,
            message: "运营联系人电话",
            trigger: "blur",
          },
          {
            min: 11,
            max: 11,
            message: "请输入正确的运营联系人电话!",
            trigger: "blur",
          },
        ],
        disabled: {
          required: true,
          message: "是否禁用",
          trigger: "blur",
        },
        accountArr: {
          parent_bank_name: {
            required: true,
            message: "开户银行名称!",
            trigger: "blur",
          },
          bank_name: {
            required: true,
            message: "开户行支行名称!",
            trigger: "blur",
          },
          union_bank: [
            {
              required: true,
              message: "请输入支付行号!",
              trigger: "blur",
            },
          ],
          province: {
            required: true,
            message: "开户行所在地区!",
            trigger: "blur",
          },
        },
      },
      dataList: [],
    };
  },
  computed: {
    ...mapGetters(["wheight"]),
  },
  components: { imgPicker, draggable },
  methods: {
    handleRegionChange: function (value) {
      var vals = getCascaderObj(value, this.regions);
      if (vals[0] != undefined) {
        this.form.accountArr.province = vals[0].label;
        this.form.accountArr.city = vals[1].label;
        this.form.accountArr.area = vals[2].label;
        console.log(vals, this.form.accountArr.regions_id);
      }
    },
    removeForm(index) {
      this.$confirm("确定要删除该资质？", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm" && index !== -1) {
               this.form.credentialArr.splice(index, 1);
          }
          done();
        },
      });
    },
    addRule() {
      this.form.credentialArr.push({
        credential_type_id: "",
        credential_expire: "",
        credential_url: "",
      });
    },
    next(val) {
      if (val == 1) {
        this.next1 = false;
        this.btn1 = true;
        this.btn2 = false;
      }
      if (val == 2) {
        this.btn1 = true;
        this.btn2 = true;
        this.next2 = false;
        this.hidden = false;
      }

    },
    getMerchantCredentialTypesList() {
      getMerchantCredentialTypes().then((res) => {
        this.typeList = res.data.data.list;
      });
    },
    selectTime() {
      var time = this.form.business_expire;
      this.form.business_expire = time;
    },
    changeTime() {
      if (this.timelimit == 0) {
        this.timelimitDisabled = false;
      } else {
        this.timelimitDisabled = true;
        this.form.business_expire = "长期有效";
      }
    },
    fetchMainCate() {
      getMerchantCategory({ ishtml: 1 }).then((res) => {
        this.mainCategory = res.data.data;
        this.mainCateLoader = false;
      });
    },
    getCategoryName() {
      getMerchantCategory({
        category_id: this.form.operating_type_id,
        getname: 1,
      }).then((res) => {
        this.categoryNames = res.data.data;
        this.loader = false;
      });
    },
    handleCategoryChange(val) {
      this.form.operating_type_id = val[1];
    },
    goBack() {
      this.$confirm("此操作返回上一个页面, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          history.back(0);
        })
        .catch(() => {});
    },
    //编辑显示数据
    getRow(id) {
      getMerchants({ merchant_id: id,is_edit:1 }).then((res) => {
        this.form = res.data.data.list[0];
        this.form.threshold_setting = (this.form.threshold_setting/100).toFixed(2);
        this.form.merchant_freight_fee = (this.form.merchant_freight_fee/100).toFixed(2);
        if (this.form.business_expire == "长期有效") {
          this.timelimit = true;
          this.changeTime();
        }
        this.getCategoryName();
      });
    },
    onSubmit(formName) {
      var submit = false;
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          console.log("error submit!!");
          return false;
        } else {
          submit = true;
        }
      });
      if (submit == false) {
        return;
      }
      var that = this;
      if (this.$route.query.id) {
        editMerchants(this.$route.query.id, this.form).then((res) => {
          if (res.status) {
            this.loading = false;
            this.$message({
              message: "修改成功",
              type: "success",
              duration: 2000,
            });
            setTimeout(function () {
              that.$router.go(-1);
            }, 2000);
          } else {
            this.$message.error("修改失败!");
            return false;
          }
        });
      } else {
        addMerchants(this.form).then((res) => {
          if (res.status) {
            this.loading = false;
            this.$message({
              message: "保存成功",
              type: "success",
              duration: 2000,
            });
            setTimeout(function () {
              that.$router.go(-1);
            }, 2000);
          } else {
            this.$message.error("保存失败!");
            return false;
          }
        });
      }
    },
    pickImg(data) {

      if (this.pickerImgType == 'credential_url') {
          this.form.credentialArr[this.credential_url_index][this.pickerImgType] =data.url;
      }else{
          this.form[this.pickerImgType] = data.url;
      }

      this.imgDialog = false;
    },
    handleImgPicker(pickerImgType, index = 0) {
      this.pickerImgType = pickerImgType;
      this.credential_url_index = index;
      this.imgDialog = true;
      this.isGetImage = true;
    },
    closeImgDialog() {
      this.imgDialog = false;
      this.isGetImage = false;
    },
  },
  mounted() {
    if (this.$route.query && this.$route.query.id != undefined) {
      this.getRow(this.$route.query.id);
      this.hidden = false;
    }
    this.getMerchantCredentialTypesList();
    this.fetchMainCate();

  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// edit.vue?3cc17d16